import React from 'react';
import Icon from '../../../components/AppIcon';

const SentimentAnalysis = ({ sentimentData }) => {
  const sentiments = [
    { 
      type: 'positive', 
      label: 'Positive', 
      icon: 'ThumbsUp', 
      color: 'text-success', 
      bgColor: 'bg-success/10',
      value: sentimentData?.positive 
    },
    { 
      type: 'neutral', 
      label: 'Neutral', 
      icon: 'Minus', 
      color: 'text-warning', 
      bgColor: 'bg-warning/10',
      value: sentimentData?.neutral 
    },
    { 
      type: 'negative', 
      label: 'Negative', 
      icon: 'ThumbsDown', 
      color: 'text-error', 
      bgColor: 'bg-error/10',
      value: sentimentData?.negative 
    }
  ];

  const total = sentimentData?.positive + sentimentData?.neutral + sentimentData?.negative;

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="MessageSquare" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-foreground">Comment Sentiment</h3>
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Overall Sentiment Score</span>
          <span className="text-2xl font-bold text-foreground">{sentimentData?.score}/10</span>
        </div>

        <div className="space-y-3">
          {sentiments?.map((sentiment) => {
            const percentage = ((sentiment?.value / total) * 100)?.toFixed(1);
            return (
              <div key={sentiment?.type}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <div className={`p-1.5 rounded ${sentiment?.bgColor}`}>
                      <Icon name={sentiment?.icon} size={14} className={sentiment?.color} />
                    </div>
                    <span className="text-sm font-medium text-foreground">{sentiment?.label}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-muted-foreground">{sentiment?.value?.toLocaleString()}</span>
                    <span className="text-sm font-semibold text-foreground">{percentage}%</span>
                  </div>
                </div>
                <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                  <div 
                    className={`h-full ${sentiment?.bgColor?.replace('/10', '')} rounded-full transition-all duration-300`}
                    style={{ width: `${percentage}%` }}
                  />
                </div>
              </div>
            );
          })}
        </div>

        <div className="border-t border-border pt-4 mt-4">
          <h4 className="text-sm font-medium text-muted-foreground mb-3">Trending Topics</h4>
          <div className="flex flex-wrap gap-2">
            {sentimentData?.trendingTopics?.map((topic, index) => (
              <span 
                key={index}
                className="px-3 py-1 bg-muted text-foreground text-xs font-medium rounded-full"
              >
                #{topic}
              </span>
            ))}
          </div>
        </div>

        <div className="border-t border-border pt-4">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Avg Response Time</span>
            <span className="text-sm font-semibold text-foreground">{sentimentData?.avgResponseTime}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SentimentAnalysis;